
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ChevronRight } from 'lucide-react';

interface ArtistRecommendationProps {
  recommendation: {
    priority: string;
    description: string;
    actionSteps: string[];
  };
  priority?: boolean;
}

const ArtistRecommendationCard: React.FC<ArtistRecommendationProps> = ({
  recommendation,
  priority = false
}) => {
  return (
    <Card className={`overflow-hidden transition-all hover:shadow-md ${priority ? 'border-soundcharts-purple' : ''}`}>
      <CardContent className="p-4">
        {priority && (
          <Badge variant="soundcharts" className="mb-2">
            Priority Focus
          </Badge>
        )}
        
        <h4 className="font-medium mb-2">{recommendation.priority}</h4>
        <p className="text-sm text-muted-foreground mb-3">{recommendation.description}</p>
        
        <div className="space-y-2 mb-4">
          {recommendation.actionSteps.map((step, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="flex-shrink-0 mt-1 w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-xs">{index + 1}</span>
              </div>
              <p className="text-sm">{step}</p>
            </div>
          ))}
        </div>
        
        <Button variant="outline" size="sm" className="w-full gap-1">
          <span>Start Working On This</span>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default ArtistRecommendationCard;
